import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  height: ', 'px;\n  background-color: currentColor;\n  border-radius: ', 'px;\n  opacity: 0.15;\n  margin-left: ', 'px;\n  width: ', ';\n'], ['\n  height: ', 'px;\n  background-color: currentColor;\n  border-radius: ', 'px;\n  opacity: 0.15;\n  margin-left: ', 'px;\n  width: ', ';\n']);

import styled from 'styled-components';

import { gridSize, math } from '@atlaskit/theme';

var SkeletonContainerItemText = styled.div(_templateObject, math.multiply(gridSize, 2.5), math.divide(gridSize, 2), gridSize() * 3, function (props) {
  return props.textWidth || gridSize() * 17 + 'px';
});

SkeletonContainerItemText.displayName = 'SkeletonContainerItemText';
export default SkeletonContainerItemText;